import React, { useEffect, useReducer, useRef, useState } from 'react'
import Modal from '../../../../../Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import styles from "./AiboxForm.module.css"
import Input from '../../../../../CustomDropDown/Input/Input';
import Button1 from '../../../../Button/Button1';
import { addAibox, addCamectAPI, addSigfoxAPI, aiboxLogin, updateCamectAPI } from '../../../../../../Api Methods/Api';
import { checkAuthLoader } from '../../../../../../auth';
import Button2 from '../../../../Button/Button2';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import Lottie from 'lottie-react';
import loadingAnim from '../../../../../../assets/animations/pleasewait.json'
import check from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import cross from '../../../../../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/cross.png'

const TextReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }

    return { value: '', isValid: false };
}

const AiboxForm = ({ setShowVirtualSource, outputs, fetchVirtualSources }) => {

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const apiData = {
        token,
        client
    }
    const [modalComponent, setModalComponent] = useState(null);
    const [modalPageIndex, setModalPageIndex] = useState(0);
    const [pinSelected, setPinSelected] = useState(null)
    const ModalDialog = useRef();
    const [message, setMessage] = useState("")
    const [invalidIP, setInvalidIP] = useState("")
    const [linkMessage, setLinkMessage] = useState("Attempting to link Ganz AiBox, please wait...")
    const [linkTitle, setLinkTitle] = useState("Logged in successfully!")
    const [loading, setLoading] = useState(false)

    const userID = useSelector(state => state.auth.userID);
    const ipRegex = /^(?:\d{1,3}\.){3}\d{1,3}$/;

    const [channels, setChannels] = useState([]);
    const [rules, setRules] = useState([]);
    const [relays, setRelays] = useState([]);

    const [selectedChannels, setSelectedChannels] = useState([])
    const [selectedRules, setSelectedRules] = useState([])
    const [selectedRelays, setSelectedRelays] = useState([])
    const [zoneName, setZoneName] = useState("")
    const [failReason, setFailReason] = useState("")


    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        HandelResetModal();
    }

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                HandelResetModal();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
      
    const [ipAddressState, dispatchIPAddressState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [portState, dispatchPortState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [usernameState, dispatchUsernameState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [passwordState, dispatchPasswordState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const ipAddressRef = useRef();
    const portRef = useRef();
    const usernameRef = useRef();
    const passwordRef = useRef();

    function validateIPAddress(value) {
        if (value == ''){
            return null
        }

        if (/^https?:\/\//i.test(value)) {
            return "Do not include http:// or https://";
        }

        if (/:\d+$/.test(value)) {
            return "Do not include port number in this field";
        }

        // if (!ipRegex.test(value)) {
        //     return "Invalid IP address format";
        // }

        return "";
    }

    const ipAddressChangeHandler = (e) => {
        const value = e.target.value;
        const errorMessage = validateIPAddress(value);

        dispatchIPAddressState({ type: "USER_INPUT", val: value });
        setInvalidIP(errorMessage);
    };


    const portChangeHandler = (event) => {
        dispatchPortState({ type: 'USER_INPUT', val: event.target.value });
    }

    const usernameChangeHandler = (event) => {
        dispatchUsernameState({ type: 'USER_INPUT', val: event.target.value });
    }

    const passwordChangeHandler = (event) => {
        dispatchPasswordState({ type: 'USER_INPUT', val: event.target.value });
    }

    const HandelResetModal = () => {
        setModalPageIndex(null);
        setShowVirtualSource(null);
    }

    const dispatch = useDispatch();

    const submitHandler = async (event) => {
        event.preventDefault();
    };

    const HandlePinSelected = (pin) => {
        setPinSelected(pin);
        setModalPageIndex(1);
    }

    const HandleLogin = async () => {
        setMessage("") //reset 
        setModalPageIndex(3)
        let loginBody = {
            "protocol": "https",
            "hostName": ipAddressState.value,
            "port": portState.value,
            "username": usernameState.value,
            "password": passwordState.value,
            "userID": userID
        }

        console.log(loginBody)

        const loginResponse = await aiboxLogin(apiData, loginBody, dispatch)
        if (loginResponse.success) {
            console.log(loginResponse)
            setModalPageIndex(4)
            setChannels(loginResponse.data.channels)
            setRules(loginResponse.data.systemRules)
            setRelays(loginResponse.data.relayOutputs)
            // const fullIP = `${ipAddressState.value}:${portState.value}`
            // let addBody = {
            //     "siteUUID": DeviceUUID,
            //     "pinNumber": pinSelected,
            //     "userID": userID,
            //     "ipAndPort": fullIP
            // }

            // //HandleCloseModal();
            // setModalPageIndex(2)

            // const linkResponse = await addAibox(apiData, addBody, dispatch)
            // if (linkResponse.success){
            //     console.log(linkResponse)
            //     //HandleCloseModal();
            //     //fetchVirtualSources();
            //     //setLinkTitle("Complete!")
            //     //setLinkMessage("AIBOX linked successfully")

            // } else {
            //     setLinkTitle("Error!")
            //     setLinkMessage("Failed to link AIBOX, please try again")
            // }
        } else {
            console.log("here?")
            setMessage("Failed to login to AIBOX, please check your credentials & try again")
        }
    }

    const HandleSelectChannel = (channel) => {
        setSelectedChannels((prevSelectedChannels) => {
            if (prevSelectedChannels.includes(channel)) {
              return prevSelectedChannels.filter((x) => x.name !== channel.name);
            } else {
              return [...prevSelectedChannels, channel];
            }
          });
    }

    const HandleSelectRule = (rule) => {
        setSelectedRules((prevSelectedRules) => {
            if (prevSelectedRules.includes(rule)) {
              return prevSelectedRules.filter((x) => x.name !== rule.name);
            } else {
              return [...prevSelectedRules, rule];
            }
          });
    }

    const HandleSelectRelay = (relay) => {
        setSelectedRelays((prevSelectedRelays) => {
            if (prevSelectedRelays.includes(relay)) {
              return prevSelectedRelays.filter((x) => x.name !== relay.name);
            } else {
              return [...prevSelectedRelays, relay];
            }
          });
    }

    useEffect(() => {
        console.log(channels)
        console.log(rules)
        console.log(relays)
        console.log(selectedChannels)
    }, [channels, rules, relays, selectedChannels])

    const HandleBack = () => {
        setModalPageIndex(4)
        setSelectedChannels([])
        setSelectedRules([])
        setSelectedRelays([])
    }

    const HandleLink = async (controlLevel) => {
        const fullIP = `${ipAddressState.value}:${portState.value}`
        let ruleUUIDs = 
            controlLevel == "hub" ? [] : 
            controlLevel == "output_relay" ? selectedRelays.map(relay => String(relay.relay_id)) : 
            controlLevel == "channel" ? selectedChannels.map(channel => String(channel.no)) :
            controlLevel == "rule" ? selectedRules.map(rule => String(rule.uuid))
            : []


        const body = {
            "siteUUID": DeviceUUID,
            "pinNumber": pinSelected,
            "userID": userID,
            "ipAndPort": fullIP,
            "zoneConfig" : [
                {
                    "zoneName": zoneName,
                    "ruleUUIDs": 
                        ruleUUIDs
                    ,
                    "controlLevel": controlLevel
                }
            ]
        }

        console.log(body)

        const linkResponse = await addAibox(apiData, body, dispatch)
        if (linkResponse.success){
            console.log(linkResponse)
            //HandleCloseModal();
            fetchVirtualSources();
            setModalPageIndex(8)
            //setLinkTitle("Complete!")
            //setLinkMessage("AIBOX linked successfully")

        } else {
            console.log(linkResponse)
            setFailReason(linkResponse)
            setModalPageIndex(9)
            //setLinkTitle("Error!")
            //setLinkMessage("Failed to link AIBOX, please try again")
        }

    }

    useEffect(() => {
        switch (modalPageIndex) {
            case 0:
                setModalComponent(
                    <form onSubmit={submitHandler} className={styles["container1"]} method="dialog">
                        <h3 style={{color:"#6e6e6e"}}>Which output would you like to link the Ganz AiBox to?</h3>
                        <br></br>
                        <small style={{color:"#6e6e6e"}}>Please make sure the AiBox and your selected output are set to the same state.</small>                        
                        <small style={{color:"#6e6e6e"}}>If they are different, the first command will only be used to sync them and</small>
                        <small style={{color:"#6e6e6e"}}>will NOT change the AiBox.</small>
                        <br></br>
                        <br></br>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "15px" }}>
                            
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                    <ul style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center", gap: "10px" }}>
                                    {outputs.map((output) => {
                                            return (
                                                <li key={output.Pin}>
                                                    <Button2 style={{minWidth:"350px", minHeight:"50px"}}type={"button"} onClick={() => HandlePinSelected(output.Pin)}>
                                                        {output.pinName}
                                                    </Button2>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </form>
                )
                HandleShowModal();
                break;
            case 1:
                setModalComponent(
                    <div className={`${styles.container}`}>
                        <div className={`${styles.card}`}>
                            {message && <p className={styles.errorMessage}>{message}</p>}
                            <h2 style={{color:"#6e6e6e"}}>Ganz AiBox Login</h2>
                            <p style={{color:"#6e6e6e"}}>Login to your account by completing the fields below</p>

                            <br></br>
                            <small style={{color:"#6e6e6e"}}>Please do not include 'https://' or port in the IP Address</small>
                            <br></br>
                            {invalidIP && <small className={styles.errorMessage}>{invalidIP}</small>}

                            <input
                                placeholder={"IP Address"}
                                ref={ipAddressRef}
                                id="ipAddress"
                                value={ipAddressState.value}
                                onChange={ipAddressChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"Port"}
                                ref={portRef}
                                id="port"
                                value={portState.value}
                                onChange={portChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Username"}
                                ref={usernameRef}
                                id="username"
                                value={usernameState.value}
                                onChange={usernameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Password"}
                                ref={passwordRef}
                                id="password"
                                value={passwordState.value}
                                onChange={passwordChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <br></br>

                            <Button severity="info" type="submit" disabled={loading} onClick={HandleLogin}>
                                {loading ? "Logging in..." : "Log in"}
                            </Button>
                        </div>
                    </div>    
                   
                )

                HandleShowModal();
            break;
            case 2: 
                setModalComponent(
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <h3 style={{color:"#6e6e6eff"}}>{linkTitle}</h3>
                        <br></br>
                        <p style={{color:"#6e6e6eff"}}>{linkMessage}</p>
                        <br></br>
                        <Button severity="info" type="submit" disabled={loading} onClick={HandleCloseModal}>
                                {"Close"}
                        </Button>
                    </div>
                )

                HandleShowModal();
            break; 
            case 3: 
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Logging in...</h3>
                    <br></br>
                    <p style={{color:"#6e6e6eff", margin:"10px"}}>Please wait, logging into Ganz AiBox</p>
                    <Lottie
                        animationData={loadingAnim}
                        loop={true}
                        style={{ width: 450, height: 450, margin: "0px" }}
                    />
                </div>
            )

            HandleShowModal();
            break;
            case 4: 
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Login successful</h3>
                    <br></br>
                    <p style={{color:"#6e6e6eff"}}>What would you like to control?</p>
                    <br></br>
                    <Button 
                        style={{width:"200px"}} 
                        className={styles.centerButton}
                        severity="secondary" 
                        type="submit" 
                        disabled={loading} 
                        badge={`${channels.length || 0}`}
                        onClick={() => setModalPageIndex(5)}
                    >
                        {`Channels`}
                    </Button>
                    <br></br>
                    <Button 
                        style={{width:"200px"}} 
                        className={styles.centerButton}
                        severity="secondary" 
                        type="submit" 
                        disabled={loading} 
                        badge={`${rules.length || 0}`}
                        onClick={() => setModalPageIndex(6)}
                        >
                            {`Rules`}
                    </Button>
                    <br></br>
                    <Button 
                        style={{width:"200px"}} 
                        className={styles.centerButton} 
                        severity="secondary" 
                        type="submit" 
                        disabled={loading} 
                        badge={`${relays.length || 0}`}
                        onClick={() => setModalPageIndex(7)}
                        >
                            {`Relays`}
                    </Button>
                    <br></br>
                    <Button 
                        style={{width:"200px"}} 
                        className={styles.centerButton} 
                        severity="secondary" 
                        type="submit" 
                        disabled={loading} 
                        onClick={() => HandleLink("hub")}
                        >
                            {"Hub"}
                    </Button>
                </div>
            )

            HandleShowModal();
        break; 
        case 5: 
            //Channels
            setModalComponent( () =>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Select the channels to control below</h3>
                    <br/>
                    {channels.length > 0 &&
                        channels.map((channel, index) => (
                            <Button
                                key={index}
                                severity="secondary"
                                outlined={!selectedChannels.includes(channel)}
                                label={`${channel.name} (${channel.no})`}   // PrimeReact uses "label"
                                style={{ marginBottom: "10px", width: "200px" }}
                                onClick={() => HandleSelectChannel(channel)}
                            />
                        ))
                    }
                    <br/>

                    { selectedChannels.length > 0 && (<div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
                        <label htmlFor="username">Zone name</label>
                        <InputText 
                            onChange={(e) => setZoneName(e.target.value)} 
                            id="username" 
                            value={zoneName}
                            aria-describedby="username-help" 
                        />
                        <small id="username-help">
                            Set a name for the zone being controlled.
                        </small>
                    </div>)}
         
                    <br/>
                    <Button
                        label={"Finish"} 
                        disabled={selectedChannels.length == 0}

                        severity="success"   // PrimeReact uses "label"
                        style={{ marginBottom: "10px", width: "200px" }}
                        onClick={() => HandleLink("channel")}
                    />
                    <Button
                        label={"Back to options"} 
                        severity="danger" outlined  // PrimeReact uses "label"
                        style={{ marginBottom: "10px", width: "200px" }}
                        onClick={() => HandleBack()}
                    />


                </div>
            )

            HandleShowModal();
            break;
        case 6:
            //Rules
            setModalComponent( () =>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Select the rules to control below</h3>
                    <br/>
                    {rules.length > 0 &&
                        rules.map((rule, index) => (
                            <Button
                                key={index}
                                severity="secondary"
                                outlined={!selectedRules.includes(rule)}
                                label={rule.name}   // PrimeReact uses "label"
                                style={{ marginBottom: "10px", width: "200px" }}
                                onClick={() => HandleSelectRule(rule)}
                            />
                        ))
                    }
                    <br/>

                    { selectedRules.length > 0 && (<div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
                        <label htmlFor="username">Zone name</label>
                        <InputText value={zoneName} onChange={(e) => setZoneName(e.target.value)} id="username" aria-describedby="username-help" />
                        <small id="username-help">
                            Set a name for the zone being controlled.
                        </small>
                    </div>)}

                    <br/>
                    <Button
                        label={"Finish"} 
                        disabled={selectedRules.length == 0}
                        severity="success"   // PrimeReact uses "label"
                        style={{ marginBottom: "10px", width: "200px" }}
                        onClick={() => HandleLink("rule")}
                    />
                    <Button
                        label={"Back to options"}  
                        severity="danger" outlined // PrimeReact uses "label"
                        style={{ marginBottom: "10px", width: "200px" }}
                        onClick={() => HandleBack()}
                    />
                </div>
            )

            HandleShowModal();
        break;
        case 7:
            setModalComponent( () =>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <h3 style={{color:"#6e6e6eff"}}>Select the relays to control below</h3>
                    <br/>
                    {relays.length > 0 &&
                        relays.map((relay, index) => (
                            <Button
                                key={index}
                                severity='secondary'
                                outlined={!selectedRelays.includes(relay)}
                                label={relay.name}   // PrimeReact uses "label"
                                style={{ marginBottom: "10px", width: "200px" }}
                                onClick={() => HandleSelectRelay(relay)}
                            />
                        ))
                    }
                    <br/>

                    { selectedRelays.length > 0 && (<div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
                        <label htmlFor="username">Zone name</label>
                        <InputText value={zoneName} onChange={(e) => setZoneName(e.target.value)} id="username" aria-describedby="username-help" />
                        <small id="username-help">
                            Set a name for the zone being controlled.
                        </small>
                    </div>)}

                    <br/>

                    <Button
                        label={"Finish"} 
                        severity="success" 
                        disabled={selectedRelays.length == 0}
                        style={{ marginBottom: "10px", width: "200px" }}
                        onClick={() => HandleLink("output_relay")}
                    />
                    <Button
                        label={"Back to options"} 
                        severity="danger" outlined  // PrimeReact uses "label"
                        style={{ marginBottom: "10px", width: "200px" }}
                        onClick={() => HandleBack()}
                    />
                </div>
            )

            HandleShowModal();
        break;
        case 8:
            //success
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                    <img className={styles.ModalIcon} src={check}>
                    </img>
                    <br></br>
                    <br></br>
                    <div>
                        <h3 style={{ textAlign: "center", color: "#858585" }}>Ganz AiBox linked successfully!</h3>
                    </div>
                    <br></br>
                    <br></br>
                    <div>
                        <br></br>
                        <Button 
                            onClick={() => HandleCloseModal()} 
                            style={{ width: "100%" }}
                            severity='secondary'
                            label='Close'
                        />
                    </div>
                </div>
            )
            HandleShowModal();
        break;
        case 9:
            //fail 
            setModalComponent(
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                  <img className={styles.ModalIcon} src={cross}>
                  </img>
                  <br></br>
                  <br></br>
                  <div>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>Failed to link Ganz AiBox</h3>
                    <h3 style={{ textAlign: "center", color: "#858585" }}>{failReason}</h3>
                  </div>
                  <br></br>
                  <br></br>
                  <div>
                    <br></br>
                    <Button1 onClick={HandleCloseModal} style={{ width: "100%" }}>Close</Button1>
                  </div>
                </div>
              )
            
            HandleShowModal();
        break; 
        
        }
    }, [modalPageIndex, ipAddressState, portState, usernameState, passwordState, linkMessage, linkTitle, message, selectedChannels, selectedRelays, selectedRules, zoneName, failReason]);

    return (
        <>
            <Modal ref={ModalDialog} title={"Link Ganz AiBox"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>
        </>
    )
}

export default AiboxForm;